import { createActionCreator } from 'deox';
import { BreadPluginConfig, PluginConfig } from '../models/plugin.model';

export const contentAddedToDom = createActionCreator(
  'CONTENT_ADDED_TO_DOM',
  resolve => (payload: {
    domTarget: HTMLElement
  }) => resolve(payload),
);

export const initPlugins = createActionCreator(
  'INIT_PLUGINS',
);

export const initBreadPlugin = createActionCreator(
  'INIT_BREAD_PLUGIN',
  resolve => (
    payload: BreadPluginConfig
  ) => resolve(payload)
);

export const contentAddedToDomBread = createActionCreator(
  'CONTENT_ADDED_TO_DOM_BREAD',
  resolve => (payload: {
    domTarget: HTMLElement
  }) => resolve(payload),
);